import React, { useEffect, useState } from "react";
import feather from 'feather-icons';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ReactSession } from 'react-client-session';
import { useRef } from "react";

ReactSession.setStoreType("localStorage");


const Header = () => {
    const userId = ReactSession.get("welbeinguserId");
    const [categories, setCategories] = useState([]);
    const [cartCount, setcartCount] = useState(0);
    const [cartItems, setCartItems] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchedProducts, setSearchedProducts] = useState([]);
    const [showDropDown, setShowDropDown] = useState(false);
    const [wishlistCount, setWishlistCount] = useState(0);
    const [wishlistItems, setWishlistItems] = useState([]);
    const [isFixed, setIsFixed] = useState(false);

    const categoryRef = useRef(null);
    const categoryOffsetTop = useRef(0);

    const navigate = useNavigate();

    useEffect(() => {
        if (categoryRef.current) {
            categoryOffsetTop.current = categoryRef.current.offsetTop;
        }

        const handleScroll = () => {
            setIsFixed(window.scrollY >= categoryOffsetTop.current);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);


    if (!ReactSession.get("welbeinguserId")) {
        ReactSession.set("welbeinguserId", "0");
    }


    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await fetch("https://api.welbeing.in/header/");
                if (!response.ok) {
                    throw new Error('Failed to fetch categories');
                }
                const data = await response.json();
                if (data.status === 'success') {
                    setCategories(data.data);
                } else {
                    throw new Error(data.error?.message || "Unknown error occurred");
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        fetchCategories();
    }, []);

    const handleSearchChange = async (e) => {
        const query = e.target.value;
        setSearchQuery(query);
        const data = { name: query };
        try {
            const response = await axios.post('https://api.welbeing.in/product/search-product/', data);
            setSearchedProducts(response.data.data || '');
            setShowDropDown(true);
        } catch (error) {
            console.error('Error fetching products:', error);
            setSearchedProducts([]);
            setShowDropDown(false);
        }
    };

    const WishlistCount = () => {
        const items = JSON.parse(sessionStorage.getItem("wishlistItems")) || [];
        setWishlistItems(items);
        setWishlistCount(items.length);
    }
    useEffect(() => {
        WishlistCount();
        window.addEventListener('wishlistUpdated', WishlistCount);
        return () => {
            window.removeEventListener('wishlistUpdated', WishlistCount);
        };
    }, []);

    const removeFromWishlist = (index) => {
        const updatedWishlist = [...wishlistItems];
        updatedWishlist.splice(index, 1);
        sessionStorage.setItem('wishlistItems', JSON.stringify(updatedWishlist));
        setWishlistItems(updatedWishlist);
        setWishlistCount(updatedWishlist.length);
        window.dispatchEvent(new Event('wishlistUpdated'));
    };

    useEffect(() => {
        feather.replace();
    }, [categories]);

    const CartCounts = () => {
        const cartItems = JSON.parse(sessionStorage.getItem("cartItems")) || [];
        setCartItems(cartItems);
        setcartCount(cartItems.length);
    };

    useEffect(() => {
        CartCounts();
        window.addEventListener('storage', CartCounts);
        window.addEventListener('cartUpdated', CartCounts);
        return () => {
            window.removeEventListener('storage', CartCounts);
            window.removeEventListener('cartUpdated', CartCounts);
        }
    }, []);

    const removeFromCart = (index) => {
        const updatedCart = [...cartItems];
        updatedCart.splice(index, 1);
        sessionStorage.setItem('cartItems', JSON.stringify(updatedCart));
        setCartItems(updatedCart);
        setcartCount(updatedCart);
        window.dispatchEvent(new Event('cartUpdated'));
    };

    const calculateCartTotal = () => {
        return cartItems.reduce((total, item) => total + (item.price * item.quantity), 0);
    }

    const handlelogout = (e) => {
        e.preventDefault();
        ReactSession.set("welbeinguserId", "0");
        ReactSession.set("welbeinguserName", "");
        ReactSession.set("welbeingemail", "");
        ReactSession.set("welbeingphonenumber", "");
        ReactSession.set("welbeinggender", "");
        ReactSession.set("welbeingprofile", "");
        sessionStorage.removeItem("cartItems");
        sessionStorage.removeItem("coupon");
        sessionStorage.removeItem("offer");
        navigate('/login');
    };

    return (
        <>
            {/* Header */}
            <header className={`header-common header3 ${isFixed ? 'is-fixed fixed-header' : ''}`} id="header">
                <div className="top-header bg-theme-theme">
                    <div className="container-lg">
                        <div className="topheader-wrap">
                            <h1 className="marquee"><span>+91 904747 3959 | Jute Bags, Tamboolam Bags, Handbags, Gift Bags </span></h1>
                        </div>
                    </div>
                </div>

                <div className="container-lg">
                    <div className="nav-wrap">
                        <nav className="navigation">
                            <div className="nav-section">
                                <div className="header-section">
                                    <div className="navbar navbar-expand-xl navbar-light navbar-sticky p-0">
                                        <div className="d-flex logo-wraper">
                                            <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#primaryMenu" aria-controls="primaryMenu">
                                                <span className="navbar-toggler-icon"></span>
                                            </button>
                                            <a href="/" className="logo-link">
                                                <img className="logo logo-dark" src="assets/img/logo/logo.png" alt="logo" loading="eager" />
                                                <img className="logo logo-light" src="assets/img/logo/logo.png" alt="logo" loading="eager" />
                                            </a>
                                        </div>

                                        <div className="header-center">
                                            <div className="search-header">
                                                <div className="search-bar">
                                                    <div className="input-group">
                                                        <div className="input-group-prepend"></div>
                                                        <input className="form-control search-type" type="search" id="search-box" placeholder="Search here..." onChange={handleSearchChange} onFocus={() => setShowDropDown(searchedProducts.length > 0)} />
                                                        <div className="input-group-append">
                                                            <span className="input-group-text">
                                                                <button className="submit" type="submit"></button>
                                                                <i className="d-none d-lg-block search-b" data-feather="search"></i>
                                                                <i className="close-b d-lg-none" data-feather="x"></i>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {showDropDown && searchedProducts.length > 0 &&
                                                        <div className="search-suggestion" style={{ float: 'left', backgroundColor: '#fff' }}>
                                                            <ul className="tags tag" id="myItem">
                                                                {searchedProducts.map((product, index) => (
                                                                    <li key={index}>
                                                                        <a href={`/singleproduct?id=${product.p_id}`} style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>{product.item_name}</a>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </nav>
                        <div className="menu-right">
                            <ul className="icon-menu">
                                <li className="user">
                                    <a className="text-black" href="/">Home</a>
                                </li>
                                <li className="user">
                                    <a className="text-black" href="/about">About Us</a>
                                </li>
                                <li className="user">
                                    <a className="text-black" href="/contact">Contact Us</a>
                                </li>
                                <li className="user">
                                    <div className="dropdown user-dropdown">
                                        <a href=""><i data-feather="user"></i></a>
                                        {userId === '0' ? (
                                            <ul className="onhover-show-div">
                                                <li><a href="/login">Login</a></li>
                                            </ul>
                                        ) : (
                                            <ul className="onhover-show-div">
                                                <li><a onClick={handlelogout}>Logout</a></li>
                                                <li><a href="/accounts">Account</a></li>
                                            </ul>
                                        )}
                                    </div>
                                </li>
                                <li>
                                    <div className="dropdown shopingbag">
                                        <a href=""><i data-feather="heart"></i>
                                            <span className="notification-label" id="wish-count">
                                                {wishlistCount > 0 ? wishlistCount : 0}
                                            </span>
                                        </a>
                                        <div className="onhover-show-div" id="wishitems">
                                            <div className="card-wrap custom-scroll d-flex flex-column">
                                                {userId === '0' ? (
                                                    <div align="center">
                                                        <h6 className="mb-0">Please Login!</h6>
                                                        <p className="">Login to access your account.</p>
                                                        <a href="/login" className="btn btn-danger">Login Now</a>
                                                    </div>
                                                ) : (
                                                    <>
                                                        {wishlistItems.length === 0 ? (
                                                            <div align="center">
                                                                <h6 className="mb-0">Your Wishlist is empty!</h6>
                                                                <p className="mb-2">Add some products to your wishlist.</p>
                                                                <a href="/shop" className="btn btn-danger">Shop Now</a>
                                                            </div>
                                                        ) : (
                                                            <>
                                                                <div className="wishlist-scroll overflow-auto" style={{ flex: 1 }}>
                                                                    {wishlistItems.map((item, index) => (
                                                                        <div className="cart-card media p-2 border-bottom" key={index}>
                                                                            <a href={`/singleproduct?id=${item.id}`}>
                                                                                <img src={`https://api.welbeing.in/admin/product_data/${item.image}`} className="img-fluid" alt="product" width="50" />
                                                                            </a>
                                                                            <div className="media-body ms-2">
                                                                                <a href={`/singleproduct?id=${item.id}`}>
                                                                                    <h6>{item.name}</h6>
                                                                                </a>
                                                                                <span>₹{item.price}</span>
                                                                            </div>
                                                                            <a href="#" className="remove-cart" onClick={(e) => { e.preventDefault(); removeFromWishlist(index); }}>
                                                                                <i className="fa fa-close"></i>
                                                                            </a>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                                <div className="dropdown-footer p-3">
                                                                    <div className="btn-group block-group">
                                                                        <a href="/wishlist" className="btn-solid w-100">View Wishlist</a>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className="dropdown shopingbag">
                                        <div className="side-list">
                                            <div>
                                                <a href="" className="cart-button"><i data-feather="shopping-bag"></i> <span className="notification-label" id="cart-count">{cartCount > 0 ? cartCount : 0}</span></a>
                                                <a href="" className="overlay-cart overlay-common"></a>
                                                <div className="onhover-cart-dropdown">
                                                    <div className="onhover-show-div" id="cartItems">
                                                        <div className="dropdown-header">
                                                            <div className="control">
                                                                <a href="">Shopping Cart</a>
                                                                <button className="back-cart"><i data-feather="arrow-right"></i></button>
                                                            </div>
                                                        </div>
                                                        <div className="card-wrap custom-scroll">
                                                            {cartItems.length === 0 ? (
                                                                <div className="align-center" align="center">
                                                                    <h6 className="mb-0">Your Cart is empty!</h6>
                                                                    <p className="mb-2">Please add items to your cart.</p><br /><br />
                                                                    <a href="/shop" className="btn btn-danger" style={{ marginLeft: 'auto', marginRight: 'auto' }}>View Products</a>
                                                                </div>
                                                            ) : (
                                                                <>
                                                                    {cartItems.map((item, index) => (
                                                                        <div className="cart-card media" key={index}>
                                                                            <a href={`/singleproduct?id=${item.id}`}><img src={`https://api.welbeing.in/uploads/products/${item.image}`} className="img-fluid" alt="product-image" /></a>
                                                                            <div className="media-body">
                                                                                <a href={`/singleproduct?id=${item.id}`}><h6>{item.product}</h6></a>
                                                                                <span>₹{item.price} * {item.quantity}</span>
                                                                                <div className="plus-minus"> ₹{(item.price * item.quantity).toFixed(2)}</div>
                                                                            </div>
                                                                            <a href="" className="remove-cart" onClick={() => removeFromCart(index)}><i className="fa fa-close"></i></a>
                                                                        </div>
                                                                    ))}
                                                                </>
                                                            )}
                                                        </div>
                                                        {cartItems.length > 0 && (
                                                            <div className="dropdown-footer">
                                                                <div className="btn-group block-group">
                                                                    <div className="total-price">
                                                                        <span>Total</span>
                                                                        <span>₹{calculateCartTotal().toFixed(2)}</span>
                                                                    </div>
                                                                    <a href="/cart" className="btn-solid">View Cart</a>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                {isFixed && (
                    <div style={{ height: categoryRef.current?.offsetHeight || 0 }} />
                )}

                {/* Categories */}
                <div
                    ref={categoryRef}
                    className={`sticky-menu ${isFixed ? 'fixed' : ''}`}
                >
                    <div className="container-lg bottom-header">
                        <div className="nav-wrap p-0">
                            <nav className="navigation">
                                <div className="nav-section">
                                    <div className="header-section">
                                        <div className="navbar navbar-expand-xl navbar-light navbar-sticky p-0">
                                            <div className="offcanvas offcanvas-collapse order-lg-2" id="primaryMenu">
                                                <div className="offcanvas-header navbar-shadow">
                                                    <h5 className="mt-1 mb-0">Menu</h5>
                                                    <button className="btn-close lead" type="button" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                                                </div>
                                                <div className="offcanvas-body">
                                                    <ul className="navbar-nav">
                                                        {loading ? (
                                                            <li className="nav-item">
                                                                <span className="nav-link">Loading categories...</span>
                                                            </li>
                                                        ) : (
                                                            categories?.map((categoryGroup) => (
                                                                <li
                                                                    key={categoryGroup?.category?.cat_id}
                                                                    className="nav-item dropdown"
                                                                >
                                                                    <a
                                                                        className="nav-link dropdown-toggle"
                                                                        href="#"
                                                                        role="button"
                                                                        data-bs-toggle="dropdown"
                                                                        aria-expanded="false"
                                                                    >
                                                                        {categoryGroup?.category?.cate}
                                                                    </a>

                                                                    {categoryGroup?.subcategories?.length > 0 && (
                                                                        categoryGroup.subcategories.length > 10 ? (
                                                                            <div className="dropdown-menu mega-menu">
                                                                                <div className="row">
                                                                                    {categoryGroup.subcategories.map((subcategory) => (
                                                                                        <div
                                                                                            key={subcategory?.sub_id}
                                                                                            className="col-lg-3 col-md-6 col-12"
                                                                                        >
                                                                                            <a
                                                                                                className="dropdown-item subcategory-item"
                                                                                                href={`products?id=${subcategory?.sub_id}`}
                                                                                            >   
                                                                                                <i className="bi bi-gem me-1"></i>
                                                                                                {subcategory?.sub_cate}
                                                                                            </a>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            </div>
                                                                        ) : (
                                                                            <div className="dropdown-menu">
                                                                                <div className="dropdown-column">
                                                                                    {categoryGroup.subcategories.map((subcategory) => (
                                                                                        <a
                                                                                            key={subcategory?.sub_id}
                                                                                            className="dropdown-item"
                                                                                            href={`products?id=${subcategory?.sub_id}`}
                                                                                        >   
                                                                                            <i className="bi bi-gem me-1"></i>
                                                                                            {subcategory?.sub_cate}
                                                                                        </a>
                                                                                    ))}
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    )}
                                                                </li>
                                                            ))
                                                        )}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
                {/* End of  Categories */}

            </header>
            {/* End of the Header */}
        </>
    );
};

export default Header;